import type * as React from 'react';
import { post } from '@Domain/Api';
import documentTemplateArchived, {
	type DocumentTemplateArchivedAction,
} from '@Application/Documents/Templates/Actions/documentTemplateArchived';
import documentTemplateArchiveFailed, {
	type DocumentTemplateArchiveFailedAction,
} from '@Application/Documents/Templates/Actions/documentTemplateArchiveFailed';
import type ArchiveDocumentTemplate from '@Application/Documents/Templates/Commands/ArchiveDocumentTemplate';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = DocumentTemplateArchivedAction | DocumentTemplateArchiveFailedAction;

export default (command: ArchiveDocumentTemplate) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// `204`, no body: `post<void>` with an empty object body — the endpoint takes none.
			await post<void>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/document-templates/${command.templateId}/archivals`,
				{},
			);

			const action = documentTemplateArchived({ templateId: command.templateId });
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentTemplateArchiveFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
